export default __webpack_public_path__ + "static/media/INTERMX V-Wh.fc097915.svg";